import { DatasetsCreatorState } from "../contexts/DatasetsCreatorContext"

// Reducer function
const datasetsCreatorReducer = (state: DatasetsCreatorState, action: DatasetsCreatorAction) => {
  switch (action.type) {
    case 'set_original_csv_data':
      return { ...state, originalCsvData: action.payload }

    case 'set_csv_data':
      return { ...state, csvData: action.payload }

    case 'update_form_data':
      return {
        ...state,
        formData: { ...state.formData, ...action.payload },
      }

    case 'set_selected_columns':
      return { ...state, selectedColumns: action.payload }

    case 'set_key_column':
      return { ...state, keyColumn: action.payload }

    case 'set_current_step':
      return { ...state, currentStep: action.payload }

    case 'set_loading':
      return { ...state, isLoading: action.payload }

    case 'set_error':
      return { ...state, error: action.payload }

    case 'reset_state':
      return {
        originalCsvData: null,
        csvData: null,
        formData: {
          title: '',
          description: '',
          hasHeader: true,
          dataType: 'row',
        },
        selectedColumns: [],
        keyColumn: null,
        currentStep: '',
        isLoading: false,
        error: null,
      }

    default:
      throw new Error(`Unhandled action type: ${action.type}`)
  }
}

export default datasetsCreatorReducer

// Action types
type DatasetsCreatorActionType =
  | 'set_original_csv_data'
  | 'set_csv_data'
  | 'update_form_data'
  | 'set_selected_columns'
  | 'set_key_column'
  | 'set_current_step'
  | 'set_loading'
  | 'set_error'
  | 'reset_state'

// Action interface
interface DatasetsCreatorAction {
  type: DatasetsCreatorActionType
  payload?: any
}
